<template>
  <div class="order-page">
    <div class="banner-top">
      <div class="banner-box">订单确认</div>
    </div>
    <div class="order-box">
      <div class="back-bar">
        <el-button size="small" icon="el-icon-arrow-left" @click="goBack">返回</el-button>
      </div>

      <!-- 风险提示 -->
      <div class="risk-notice">
        <div class="risk-notice-title">【风险提示】</div>
        <div class="risk-notice-content">本产品为金融市场资讯数据整合查阅服务，不属于证券投资咨询服务，不构成任何投资建议、买卖推荐或收益承诺。市场有风险，投资需谨慎，所有投资决策及相应损失由用户自行承担。</div>
        <div class="risk-notice-content">本产品为数字化在线服务，一经开通交付，非乙方违约原因不支持退款，请确认需求后下单。</div>
      </div>

      <!-- 套餐信息 -->
      <div class="section-card">
        <div class="section-title">套餐信息</div>
        <div class="summary">
          <div class="summary-item"><span class="label">套餐名称：</span><span class="value">{{ pkg.name }}</span></div>
          <div class="summary-item"><span class="label">服务期限：</span><span class="value">{{ pkg.duration }}</span></div>
          <div class="summary-item"><span class="label">套餐说明：</span><span class="value">{{ pkg.desc }}</span></div>
          <div class="summary-item"><span class="label">应付金额：</span><span class="amount">￥{{ pkg.price }}</span><span class="tax">（含税）</span></div>
        </div>
      </div>

      <!-- 联系信息（未登录时显示） -->
      <div class="section-card" v-if="!token">
        <div class="section-title">联系信息</div>
        <div class="contact-form">
          <div class="form-tip">
            <i class="el-icon-warning-outline"></i>
            您尚未登录，请填写手机号，系统将自动为您注册账户。支付完成后账户信息会显示在成功页，请妥善保存。
          </div>
          <div class="form-item">
            <label class="form-label"><span class="required">*</span>手机号：</label>
            <el-input v-model="phone" placeholder="请输入手机号" maxlength="11" class="form-input"></el-input>
          </div>
        </div>
      </div>

      <!-- 支付方式 -->
      <div class="section-card">
        <div class="section-title">支付方式</div>
        <el-radio-group v-model="payMethod" class="pay-radio">
          <el-radio label="online">在线支付（支付宝/微信）<span class="pay-rec">推荐</span></el-radio>
          <el-radio label="transfer">银行转账</el-radio>
        </el-radio-group>
      </div>

      <!-- 服务协议 -->
      <div class="section-card">
        <div class="section-title">服务协议</div>
        <div class="agreement">
          <el-checkbox v-model="agreed">我已阅读并同意</el-checkbox>
          <a class="agreement-link" @click="openAgreement">《博览金融资讯网页端个人用户服务协议》</a>与<a class="agreement-link" @click="openPrivacy">《隐私政策》</a>，确认已知悉：
          <ol class="agreement-list">
            <li>本服务为金融资讯查阅服务，不构成任何投资建议，不承诺投资收益，市场有风险，投资需谨慎；</li>
            <li>本服务为数字化在线服务，一经开通交付，不适用七日无理由退货规则；</li>
            <li>账号仅限本人使用，禁止转借、共享，违规使用将被封禁账号且不予退费。</li>
          </ol>
        </div>
      </div>

      <!-- 提交 -->
      <div class="submit-bar">
        <el-button type="primary" :class="{btnBg: agreed}" @click="onGenerateOrder">生成订单</el-button>
      </div>
    </div>

    <!-- 支付前二次确认弹窗 -->
    <el-dialog title="温馨提示" :visible.sync="confirmDialog" width="560px" :close-on-click-modal="false">
      <div class="dialog-content">
        <p>您即将购买博览金融资讯网页端服务，请再次确认：</p>
        <p>服务内容以您所选套餐为准，支付成功后系统自动开通权限，服务期限自开通之日起计算；</p>
        <p>本服务所有资讯仅供参考，不构成证券、基金等金融产品的买卖建议，投资决策及损失由您自行承担；</p>
        <p>数字化服务一经开通，非乙方违约原因不予退款，请确认需求后完成支付。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmDialog = false">取消</el-button>
        <el-button type="primary" class="btnBg" :loading="submitting" @click="doCreateOrder">确认并前往支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Packages, createOrder } from "@/api/order";
export default {
  name: "Order",
  data() {
    return {
      token: window.localStorage.getItem('token'),
      username: window.localStorage.getItem('username'),
      packageId: this.$route.query.package_id,
      payMethod: 'online',
      agreed: false,
      confirmDialog: false,
      submitting: false,
      phone: '',
      pkg: {id: '', name: '', price: 0, original_price: 0, duration: '', desc: ''},
      defaultPackages: [
        {id: 1, name: '月度会员', price: 198, original_price: 298, duration: '1个月', desc: '全站资讯畅阅1个月'},
        {id: 2, name: '季度会员', price: 528, original_price: 798, duration: '3个月', desc: '全站资讯畅阅3个月'},
        {id: 3, name: '年度会员', price: 1888, original_price: 2388, duration: '12个月', desc: '全站资讯畅阅12个月，最受欢迎'},
      ],
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getPackageDetail();
  },
  methods: {
    getPackageDetail() {
      Packages({}).then((response) => {
        if (response && (response.code === 2000 || response.code === 200) && response.data && response.data.length) {
          this.setPkg(response.data);
        } else {
          this.setPkg(this.defaultPackages);
        }
      }).catch(() => {
        this.setPkg(this.defaultPackages);
      });
    },
    setPkg(list) {
      let found = list.find(item => String(item.id) === String(this.packageId));
      if (!found) { found = list[0] || this.defaultPackages[0]; }
      this.pkg = Object.assign({}, this.pkg, found);
    },
    openAgreement() {
      if (this.payMethod === 'transfer') {
        this.$router.push({path: '/AgreementTransfer'});
      } else {
        this.$router.push({path: '/Agreement'});
      }
    },
    openPrivacy() {
      this.$router.push({path: '/Privacy'});
    },
    goBack() {
      this.$router.push({path: '/Member'});
    },
    onGenerateOrder() {
      if (!this.agreed) {
        this.$message.warning({message: '请先阅读并同意服务协议', duration: 1500, offset: 400});
        return;
      }
      // 未登录用户校验手机号
      if (!this.token) {
        if (!this.phone) {
          this.$message.warning({message: '请填写手机号', duration: 1500, offset: 400});
          return;
        }
        if (!/^1[3-9]\d{9}$/.test(this.phone)) {
          this.$message.warning({message: '请输入正确的手机号', duration: 1500, offset: 400});
          return;
        }
      }
      this.confirmDialog = true;
    },
    doCreateOrder() {
      this.submitting = true;
      const data = {
        package_id: this.pkg.id,
        pay_method: this.payMethod,
        username: this.username,
      };
      // 未登录用户传手机号，后端自动注册
      if (!this.token) {
        data.phone = this.phone;
        data.auto_register = true;
        sessionStorage.setItem('pendingPhone', this.phone);
      }
      createOrder(data).then((response) => {
        this.submitting = false;
        if (response && (response.code === 2000 || response.code === 200)) {
          const orderId = (response.data && response.data.order_id) || (response.data && response.data.id) || '';
          // 如果后端返回了新注册的账号信息，保存到 sessionStorage 供支付成功页显示
          if (response.data && response.data.account) {
            sessionStorage.setItem('newAccount', JSON.stringify(response.data.account));
          }
          if (this.payMethod === 'transfer') {
            this.$router.push({path: '/OrderTransfer', query: {order_id: orderId, amount: this.pkg.price, package_name: this.pkg.name}});
          } else {
            this.$router.push({path: '/OrderPay', query: {order_id: orderId, amount: this.pkg.price, package_name: this.pkg.name, package_id: this.packageId}});
          }
        } else {
          this.$message.error({message: (response && response.msg) || '订单创建失败，请稍后重试', duration: 2000, offset: 400});
        }
      }).catch((err) => {
        this.submitting = false;
        this.$message.error({message: '订单创建失败，请稍后重试', duration: 2000, offset: 400});
        console.log(err);
      });
    },
  }
}
</script>

<style scoped>
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
  text-align: center;
  color: #fff;
}
.banner-box {
  font-size: 30px;
  font-weight: 600;
  line-height: 100px;
}
.order-box {
  width: 1200px;
  margin: 20px auto 40px;
}
.back-bar {
  margin-bottom: 16px;
}
.risk-notice {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 16px 20px;
  margin-bottom: 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.risk-notice-title {
  color: #d4380d;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
.risk-notice-content {
  color: #5c3a00;
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 4px;
}
.section-card {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #001646;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 16px;
}
.summary-item {
  font-size: 15px;
  line-height: 32px;
  color: #313131;
}
.summary-item .label {
  color: #898989;
}
.summary-item .amount {
  color: #d4380d;
  font-size: 22px;
  font-weight: 700;
}
.summary-item .tax {
  color: #d4380d;
  font-size: 13px;
  margin-left: 4px;
}
.contact-form {
  padding: 10px 0;
}
.form-tip {
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
  color: #d4380d;
  line-height: 22px;
  margin-bottom: 16px;
}
.form-tip i {
  margin-right: 4px;
}
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.form-label {
  width: 100px;
  font-size: 14px;
  color: #303133;
  text-align: right;
  padding-right: 12px;
}
.form-label .required {
  color: #d4380d;
  margin-right: 2px;
}
>>> .form-input {
  width: 280px;
}
>>> .form-input.short {
  width: 200px;
}
.pay-radio {
  font-size: 15px;
}
>>> .pay-radio .el-radio {
  margin-right: 40px;
}
>>> .pay-radio .el-radio__input.is-checked .el-radio__inner {
  background-color: #001646;
  border-color: #001646;
}
>>> .pay-radio .el-radio__input.is-checked + .el-radio__label {
  color: #001646;
  font-weight: 600;
}
.pay-rec {
  display: inline-block;
  background: #d4380d;
  color: #fff;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 8px;
  margin-left: 6px;
  vertical-align: middle;
  font-weight: normal;
}
.agreement {
  font-size: 14px;
  line-height: 26px;
  color: #595959;
}
.agreement ::v-deep .el-checkbox {
  margin-right: 4px;
}
::v-deep .agreement .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #001646;
  border-color: #001646;
}
::v-deep .agreement .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #001646;
}
::v-deep .agreement .el-checkbox__inner {
  border-color: #dcdfe6;
}
::v-deep .agreement .el-checkbox__inner:hover {
  border-color: #001646;
}
.agreement-link {
  color: #001646;
  text-decoration: underline;
  cursor: pointer;
  margin: 0 2px;
}
.agreement-link:hover {
  color: #0a2a6e;
}
.agreement-list {
  margin-top: 8px;
  padding-left: 20px;
  color: #595959;
}
.agreement-list li {
  line-height: 24px;
  margin-bottom: 4px;
}
.submit-bar {
  text-align: center;
  padding: 10px 0 20px;
}
>>> .submit-bar .el-button--primary {
  width: 260px;
  height: 46px;
  font-size: 16px;
  background-color: #87b5f9;
  border-color: #87b5f9;
}
>>> .submit-bar .btnBg {
  background-color: #001646 !important;
  border-color: #001646 !important;
}
>>> .submit-bar .btnBg:hover,
>>> .submit-bar .btnBg:focus {
  background-color: #0a2a6e !important;
  border-color: #0a2a6e !important;
}
.dialog-content p {
  font-size: 14px;
  line-height: 26px;
  color: #595959;
  margin-bottom: 6px;
}
>>> .btnBg {
  background-color: #001646 !important;
  border-color: #001646 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue